import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  useGetDialogQuery,
  usePostMessageMutation,
} from "../../dialogs/dialogsSlice";
import { useDispatch } from "react-redux";
import { openRightPanel, closeRightPanel } from "../../../app/rightPanelSlice";

const useChatPage = () => {
  const dispatch = useDispatch();
  const { dialogId } = useParams();
  // const [waiting, setWaiting] = useState();
  const [messageCounter, setMessageCounter] = useState();
  const [messages, setMessages] = useState();

  // const counterRef = useRef();
  const currentDialog = useGetDialogQuery(
    { dialogId, from: messageCounter },
    { skip: dialogId == null || dialogId === "new" || messageCounter == null }
  );
  const [postMessageMutation, { isLoading: responseLoading }] =
    usePostMessageMutation();
  /*
  const checkForUpdates = () => {
    counterRef.current =
      (counterRef.current == null ? 0 : counterRef.current) + 1;
    if (counterRef.current < 5) {
      setWaiting((state) => (state !== true ? true : state));
      setTimeout(() => {
        checkForUpdates();
      }, 1000);
    } else {
      counterRef.current = 0;
      setWaiting((state) => (state !== false ? false : state));
    }
  };
*/
  const postNewMessage = async ({ text }) => {
    let result;
    try {
      result = await postMessageMutation({
        params: { dialogId },
        body: { text },
      });
      if (result?.data?.last_entry != null) {
        setMessageCounter(result?.data?.last_entry);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = (text) => {
    setMessages((state) => {
      const newMessage = {
        text,
        id: { dialog_id: dialogId, no: state.length + 1 },
        role: "USER",
      };
      if (state === null) {
        return [newMessage];
      } else {
        return [...state, newMessage];
      }
    });
    postNewMessage({ text });
    // checkForUpdates();
  };

  useEffect(() => {
    if (currentDialog?.status !== "fulfilled") return;
    const newMessages = currentDialog?.data?.messages ?? [];
    setMessages((prevMessages) => {
      const combined = [...(prevMessages || []), ...newMessages];
      const uniqueMessages = Array.from(
        new Map(
          combined.map((msg) => [`${msg.id.dialog_id}-${msg.id.no}`, msg])
        ).values()
      );
      return uniqueMessages.sort((a, b) => a.id.no - b.id.no);
    });
    if (!!currentDialog?.data?.canvas) {
      dispatch(openRightPanel({ content: "canvas" }));
    }
    // eslint-disable-next-line
  }, [currentDialog?.status]);

  useEffect(() => {
    setMessageCounter((state) => {
      if (state == null) return 0;
      return state;
    });
    return () => {
      dispatch(closeRightPanel());
    };
    // eslint-disable-next-line
  }, []);

  return {
    messages,
    onSubmit: handleSubmit,
    composerEnabled: currentDialog?.data?.status === "READY",
    waiting: currentDialog?.isLoading || responseLoading,
  };
};

export default useChatPage;
